const UMAMI_ID = '3567a4ba-382e-4273-88fd-ce6576152654'
const AHREFS_KEY = 'PC7LBWd6ChthT7BEksVAYA'
const REFINDIE_PROGRAM_ID = '201'

function appendScript(src: string, attrs: Record<string, string>) {
	if (document.querySelector(`script[src="${src}"]`)) return
	const script = document.createElement('script')
	script.src = src
	Object.entries(attrs).forEach(([key, value]) => {
		script.setAttribute(key, value)
	})
	document.head.appendChild(script)
}

export function isFeedbaskProductionHost() {
	return window.location.hostname.endsWith('feedbask.com')
}

export function loadConsentedThirdPartyScripts() {
	if (isFeedbaskProductionHost()) {
		appendScript('https://cloud.umami.is/script.js', {
			defer: 'true',
			'data-website-id': UMAMI_ID,
		})
		appendScript('https://analytics.ahrefs.com/analytics.js', {
			async: 'true',
			'data-key': AHREFS_KEY,
		})
	}
	appendScript('https://www.refindie.com/refindie.js', {
		async: 'true',
		'data-program-id': REFINDIE_PROGRAM_ID,
	})
}
